import { useCallback } from 'react';

import { fg } from '@confluence/feature-gating';

import featureGates from '../database-feature-gates.json';

export type DatabaseFeatureGate = keyof typeof featureGates;

export const useIsDatabaseFeatureEnabled = () => {
	const isDatabaseFeatureEnabled = useCallback((featureName: DatabaseFeatureGate) => {
		if (featureName in featureGates) {
			const activeFeatureGate = featureName as DatabaseFeatureGate;
			const featureGateKey = featureGates[activeFeatureGate];
			return fg(featureGateKey);
		}

		return false;
	}, []);

	return {
		isDatabaseFeatureEnabled,
	};
};
